import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};

export const getAIModelSetupsList = async () => {
  return await axiosInstance.get("ai/model-setups/getlist", { headers });
};

export const getAIModelSetupById = async (id) => {
  const response = await axiosInstance.get(`ai/model-setups/get/${id}`, {
    headers,
  });
  return response.data.result;
};

export const addAIModelSetup = async (payload) => {
  return await axiosInstance.post("ai/model-setups/add", payload, { headers });
};

export const updateAIModelSetup = async (payload) => {
  return await axiosInstance.put("ai/model-setups/update", payload, { headers });
};

export const deleteAIModelSetup = async (id) => {
  return await axiosInstance.delete(`ai/model-setups/delete/${id}`, { headers });
};

export const getActiveAIModelSetupsList = async () => {
  return await axiosInstance.get("ai/model-setups/get-active-list", { headers });
};
